export const baseComponentMixin = {
  inheritAttrs: false
};
